import { BaseEntity } from '@/actions/dtos/baseEntity';
import { Organization } from '@/actions/dtos/organisation';
import { Member } from '@/actions/dtos/organisation';
import { SearchExecution } from '@/actions/dtos/search/searchExecution';
import { Query } from '@/actions/dtos/search/query';
import { Tender } from '@/actions/dtos/tender/tender';

export enum ExecutionInterval {
  DAILY = 'Täglich',
  WEEKLY = 'Wöchentlich',
  BI_WEEKLY = 'Zweiwöchentlich',
  MONTHLY = 'Monatlich',
}

export interface SearchAgent extends BaseEntity {
  name: string;
  enabled: boolean;
  organization: Organization;
  notificationsEnabled: boolean;
  recipients: Member[];
  query: Query;
  latestExecution?: SearchExecution;
  interval: ExecutionInterval;
}

export interface SearchAgentResults extends BaseEntity {
  execution: SearchExecution;
  tender: Tender;
  rank: number;
  score: number;
}
